const SCROLLED_CLASS = 'SiteHeader--scrolled';
const headerOffset = 24;
const siteHeader = document.querySelector('[data-site-header]');

if (!siteHeader) {
    // Header is absent on blank templates.
} else {
    const toggleScrolledHeader = () => {
        window.scrollY > headerOffset
            ? siteHeader.classList.add(SCROLLED_CLASS)
            : siteHeader.classList.remove(SCROLLED_CLASS);
    };

    window.addEventListener('scroll', toggleScrolledHeader, { passive: true });

    toggleScrolledHeader();
}
